/* eslint-disable react/jsx-pascal-case */
import React from "react";
import MainLayout from "../components/layouts/mainLayout";
import Home from "../pages/home";
import Test from "../pages/test";
import NotFound from "../pages/notFound";
import ProduitDetail from "../pages/detail_produit";
import CategoryPage from "../pages/category_page";
import Categories from "../pages/categories";
import CategorieDetails from "../pages/categories/details";
import Commandes from "../pages/commandes";
import Details from "../pages/commandes/details";
import Transporteur from "../pages/transporteurs";
import Request from "../pages/transporteurs/request";
import Otp from "../pages/otp";
import Signup from "../pages/signup";
import PasserCommande from "../pages/passer_commande";
import PaieSous from "../pages/paiement_souscrip";
import RecherTrans from "../pages/recherche_trans";
import DetailTrans from "../pages/detail_trans";
import ProducteurDetails from "../pages/producteur/details";
import Cart from "../pages/Cart";
import Adresse from "../pages/livraison/adresse";
import Paiement from "../pages/achat/paiement";
import MesRequette from "../pages/mes_requettes";
import SelectProd from "../pages/select_prod";
import ListProd from "../pages/list-Prod";
import Prices from "../pages/souscriptions/prices";
import ListQuaotation from "../pages/quotation/listQuaotation";
import DetailQuotation from "../pages/quotation/detailQuotation";
import PaiementTrans from "../pages/paiement_transport";
import ListProduitHome from "../pages/home/listProduit";
import Duree from "../pages/souscriptions/durre";
import SelectProducts from "../pages/souscriptions/selectProducts";
import ConsulterPrix from "../pages/consulterPrix";
import Departement from "../pages/consulterPrix/departement";
import PriceAnalysis from "../components/chart/PriceAnalysis";
import Market from "../components/chart/Market";
import Add_Producteur from "../pages/producteur/Add_Producteur";
import Add_transporteur from "../pages/transporteurs/Add_transporteur";
import Products from "../pages/products/Products";
import CommingSoon from "../pages/commingsoon/CommingSoon";
import List_Producteur from "../pages/producteur/List_Producteur";
import Detail_Producteur from "../pages/producteur/Detail_Producteur";
import Comming_Stock from "../pages/commingsoon/Comming_Stock";

interface RouteType {
  path: string;
  element: React.ReactNode;
  children?: RouteType[];
}

const routes: RouteType[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/test", element: <Test /> },
      { path: "/detail_produit/:id", element: <ProduitDetail /> },
      { path: "/categories", element: <Categories /> },
      { path: "/details_categories", element: <CategorieDetails /> },
      { path: "/detail_producteur", element: <Detail_Producteur /> },
      { path: "/category_page", element: <CategoryPage /> },
      { path: "/commandes", element: <Commandes /> },
      { path: "/details_commandes/:id", element: <Details /> },
      { path: "/transport", element: <Transporteur /> },
      { path: "/transporteurs_details", element: <Commandes /> },
      { path: "/transporteurs_request", element: <Request /> },
      { path: "/producteur_details", element: <ProducteurDetails /> },
      { path: "/cart", element: <Cart /> },
      { path: "/Adresse_Livraison", element: <Adresse /> },
      { path: "/Mes_requettes", element: <MesRequette /> },
      { path: "/select_prod", element: <SelectProd /> },
      { path: "/comming_stock", element: <Comming_Stock /> },
      { path: "/comming_meteo", element: <CommingSoon /> },

      { path: "/souscriptions_prices", element: <Prices /> },
      { path: "/souscriptions_duree/:id", element: <Duree /> },
      { path: "/selected_product/", element: <SelectProducts /> },
      { path: "/consulter/", element: <ConsulterPrix /> },
      { path: "/consulter/departement/:idRegion", element: <Departement /> },

      { path: "/quotation_list", element: <ListQuaotation /> },

      { path: "/liste_produit_home", element: <ListProduitHome /> },
      { path: "/liste_producteur", element: <List_Producteur /> },
      { path:"/devenir_producteur", element:<Add_Producteur/> },
      { path:"/devenir_transporteur", element:<Add_transporteur/> },

      { path: "/details_quaotation/:id", element: <DetailQuotation /> },

      {path:"/list_products", element:<Products/>},

      { path: "/passer_commande", element: <PasserCommande /> },

      { path: "/paiement_trans/:id", element: <PaiementTrans /> },

      { path: "/paiement_sous", element: <PaieSous /> },
      { path: "/recherche_trans/:id", element: <RecherTrans /> },
      { path: "/recherche_trans", element: <RecherTrans /> },
      { path: "/detail_trans/:id", element: <DetailTrans /> },
      { path: "/paiement_achat/:id", element: <Paiement /> },
      { path: "/list_prod", element: <ListProd /> },
      { path: "/analyse", element: <PriceAnalysis /> },
      { path: "/market", element: <Market /> },


      
    ],
  },
  { path: "*", element: <NotFound /> },
  { path: "/signup_otp", element: <Otp /> },
  { path: "/signup", element: <Signup /> },
];

export default routes;
